// removed by extract-text-webpack-plugin
module.exports = {"list":"PostsList__list___gzMxj","element":"PostsList__element___NLqvn"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Layout/PostsList.scss
// module id = 550
// module chunks = 0